<div class="custom-input-wrapper"  [style.margin-bottom]="isEditing ? '50px' : '1rem'">
    <div class="custom-input-container" *ngIf="!isEditing" (click)="showInput()">
      <div class="custom-input-value">{{value || placeholder}}</div>
    </div>
    
    <div class="custom-input-container" *ngIf="isEditing">
      <input 
        type="text" 
        class="custom-input" 
        [(ngModel)]="tempValue" 
        [disabled]="disabled" 
        [placeholder]="placeholder"
      >
      <div class="custom-input-button-list">
        <div class="save-button" (click)="save()">
          <op-icon icon-classes="icon-checkmark"></op-icon>
        </div>
        <div class="cancel-button" (click)="cancel()">
          <op-icon icon-classes="icon-close"></op-icon>
        </div>
      </div>
    </div>
  </div>